import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import customerMappingComponent from './customer-mapping.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let customerMappingModule = angular.module('customerMapping', [
  uiRouter,
  modal,
  datepickerPopup,
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider.state('quickbooks-customer-mapping', {
    parent: 'app',
    url: '/admin/integrations/quickbooks/customer-mapping',
    data: {
      pageHeader: true,
      pageTitle: 'Quickbooks Customer Mapping Capability',
      pageDesc: '',
      breadcrumbLink: 'quickbooks',
      breadcrumbText: 'Quickbooks Capabilities'
    },
    template: '<customer-mapping></customer-mapping>'
  })

})

.component('customerMapping', customerMappingComponent);

export default customerMappingModule;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/customer-mapping/customer-mapping.js